import React, { useState } from "react";
import "../styles/Contact.css";
import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import {
  CONTACT_EMAIL,
  CONTACT_LOCATION,
  CONTACT_PHONE_DISPLAY,
  SOCIAL_LINKS,
  buildWhatsAppMessage,
  openWhatsAppChat,
} from "../data/contactConfig";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });
  const [msg, setMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = buildWhatsAppMessage(form);
    openWhatsAppChat(text);
    setMsg("Opening WhatsApp — tap Send to deliver your message.");
    setForm({ name: "", email: "", phone: "", course: "", message: "" });
  };

  return (
    <section id="contact" className="section contact-section">
      <div className="contact-header">
        <p className="section-kicker">CONTACT</p>
        <h2>Reach <span>Out.</span></h2>
        <p className="section-subtitle contact-subtitle">
          Have a question, need help choosing a course, or want a quick callback? Tell us what you need.
        </p>
      </div>

      <div className="contact-grid">
        <div className="contact-card contact-info-card">
          <p className="contact-eyebrow">WE RESPOND FAST</p>
          <h3>Talk to the team</h3>

          <div className="contact-item">
            <div className="contact-icon">☎</div>
            <div>
              <p className="contact-label">Phone / WhatsApp</p>
              <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer" className="contact-value contact-link">
                {CONTACT_PHONE_DISPLAY}
              </a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">✉</div>
            <div>
              <p className="contact-label">Email</p>
              <a href={`mailto:${CONTACT_EMAIL}`} className="contact-value contact-link">
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">⌂</div>
            <div>
              <p className="contact-label">Headquarters</p>
              <p className="contact-value">{CONTACT_LOCATION}</p>
            </div>
          </div>

          <div className="contact-mini-banner">
            <strong>Usually replies within a few hours.</strong>
            <span>Share your goal and we&apos;ll point you to the right path.</span>
          </div>

          <p className="contact-note">
            Prefer quick messaging or want to see our updates? Reach us on your favorite channel.
          </p>

          <div className="footer-socials">
            <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer" className="icon whatsapp" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="icon instagram" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noreferrer" className="icon youtube" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noreferrer" className="icon linkedin" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>

        <div className="contact-card contact-form-card">
          <p className="contact-eyebrow">SEND A NOTE</p>
          <h3>Write to us</h3>

          <form onSubmit={handleSubmit}>
            <label>
              <span>Full Name</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </label>

            <div className="form-row">
              <label>
                <span>Email</span>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  required
                />
              </label>

              <label>
                <span>Phone</span>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Your phone"
                  required
                />
              </label>
            </div>

            <label>
              <span>Interested Course / Service</span>
              <input
                type="text"
                name="course"
                value={form.course}
                onChange={handleChange}
                placeholder="DevOps, AWS, MultiCloud"
              />
            </label>

            <label>
              <span>Message</span>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Tell us a bit about what you want to learn..."
                required
              />
            </label>

            <button type="submit">Send via WhatsApp</button>
          </form>

          <p className="success">{msg}</p>
        </div>
      </div>
    </section>
  );
}
